import { logDispatcher } from "src/app/core/decorators/state.decorators";
import { ContractData } from "../../interfaces/contractData";
import { ContractMap } from "../../interfaces/contractMap.model";

export namespace ContractActions {

  @logDispatcher
  export class GetContractsMap {
    static readonly type = "[Contracts] GetContractsMap"
    constructor() {}
  }

  @logDispatcher
  export class GetContractsMapSuccess {
    static readonly type = "[Contracts] GetContractsMapSuccess"
    constructor(public contracts: ContractMap[]) {}
  }

  @logDispatcher
  export class GetContracts {
    static readonly type = "[Contracts] GetContracts"
    constructor(public exerciseId: number, public zoneId: number, public isStudentsContract: number) {}
  }

  @logDispatcher
  export class GetContractsSuccess {
    static readonly type = "[Contracts] GetContractsSuccess"
    constructor(public contracts: ContractData[]) {}
  }

  @logDispatcher
  export class CopyContracts {
    static readonly type = "[Contracts] CopyContracts"
    constructor() {}
  }

  @logDispatcher
  export class CopyContractsSuccess {
    static readonly type = "[Contracts] CopyContractsSuccess"
    constructor() {}
  }

  @logDispatcher
  export class SetContractsDefaultState {
    static readonly type = "[Contracts] SetContractsDefaultState"
    constructor() {}
  }

  @logDispatcher
  export class SetCopyContractsFormDefaultState {
    static readonly type = "[Contracts] SetCopyContractsFormDefaultState"
    constructor() {}
  }

  @logDispatcher
  export class SetCopyContractsFormExercises {
    static readonly type = "[Contracts] SetCopyContractsFormExercises"
    constructor(public newExerciseId: number, public oldExerciseId: number) {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Contracts] Error';
    constructor(public error: any, public details: string) { }
  }

  @logDispatcher
  export class SetFilterCurrentExercise {
    static readonly type = '[Contracts] SetFilterCurrentExercise';
    constructor(public exerciseId: number) {}
  }
}
